// Shared constants for the parallel operation of this (legacy) management
// frontend and the new management frontend (new.management.fun-zone.de).
// The usage of both frontends is tracked via /api/v1/frontendUsage so the
// migration can be steered with data.

export const CURRENT_FRONTEND = 'legacy';

export const NEW_FRONTEND_BASE_URL = (
  import.meta.env.VITE_NEW_MANAGEMENT_URL || 'https://new.management.fun-zone.de'
).replace(/\/$/, '');

// Permanent address of this legacy frontend. From the switch-over date on,
// management.fun-zone.de serves the new dashboard, so this app is only
// reachable under its own hostname.
export const LEGACY_FRONTEND_BASE_URL = (
  import.meta.env.VITE_OLD_MANAGEMENT_URL || 'https://old.management.fun-zone.de'
).replace(/\/$/, '');

// Date on which management.fun-zone.de starts serving the new dashboard.
export const MANAGEMENT_DOMAIN_SWITCH_DATE = '1. September 2026';

// Hostname the switch-over applies to — the address staff have bookmarked.
export const SHARED_MANAGEMENT_HOSTNAME = 'management.fun-zone.de';

// Routes on which no tracking/popups should happen (not logged in).
export const PUBLIC_PATHS = new Set([
  '/',
  '/login',
  '/rfid-login',
  '/request-password-reset',
  '/reset-password',
]);

function normalizePath(pathname) {
  if (!pathname) return '/';
  const trimmed = String(pathname).trim();
  if (!trimmed) return '/';
  if (trimmed.length > 1 && trimmed.endsWith('/')) return trimmed.slice(0, -1);
  return trimmed;
}

// URL of the equivalent page in the new frontend. The rebuild ports every
// route 1:1 (see funzone-management-frontend-new src/config/menu.ts), so the
// current pathname carries over directly; the root falls back to the
// dashboard.
export function buildNewFrontendUrl(pathname) {
  const normalized = normalizePath(pathname);
  return NEW_FRONTEND_BASE_URL + (normalized === '/' ? '/welcome' : normalized);
}
